module.exports = __webpack_public_path__ + "static/feature-8783b91e9e7974a5f0cfc2ee30ed36cf.png";